import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../utils/toast.service';
import { TranslatorService } from '../utils/translator.service';
import { AuthService } from './auth.service';

@Injectable()
export class GraphqlErrorHandler {

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly toastService: ToastService,
    private readonly translator: TranslatorService
  ) { }

  handle(graphQLErrors: readonly any[]): void {

    graphQLErrors.map(({ message, locations, path }) => {

      if (typeof message === 'string') {

        if (message === 'error.duplicated_session' || message === 'error.security_control') {
          this.handlerRequest(message, 'error');
        }
        if (message === 'error.user_config_updated' || message === 'error.session_expired' || message === 'error.user_has_been_disabled') {
          this.handlerRequest(message, 'info');
        }

        if (message.startsWith('mode-maintenance')) {
          this.router.navigate(['/mode-maintenance'], JSON.parse(message.split('#')[1]));
          return;
        }
      }
    });

  }

  private handlerRequest(message, type) {

    this.toastService.showToastWithConfig({
      type,
      title: this.translator.trans(`${message}.title`),
      body: this.translator.trans(`${message}.body`),
      timeout: 15000
    });

    this.authService.logout();

    this.router.navigate(['/']);
  }
}
